<template>
  <main>
    <div class="heading">
      <h1>
        {{$ml.get(`Dashboard`)}}
      </h1>
      <!-- <router-link :to="'/dashboard/plans'" class="step-btn">{{$ml.get(`Check our plans`)}}</router-link> -->
    </div>
    <!-- <company-dashboard /> -->
    <!-- <company-dashboard v-if="$store.getters['user/data'].globalRole == 'company'" /> -->
    <!-- <default-dashboard v-else /> -->
  </main>
</template>

<script>
// import CompanyDashboard from '@/components/dashboard/company/Index.vue'
import DefaultDashboard from '@/components/dashboard/default/Index.vue'
export default {
  components : {
    DefaultDashboard,
    // CompanyDashboard,
  },
  created () {
    if (this.$store.getters['user/data'].globalRole != 'company') {
      this.$router.push('/dashboard/farms/map-view');
    }
  }
}
</script>

<style lang="scss" scoped>
main {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  .heading {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
}
</style>
